import { ConfigInterface } from '../exports/Interfaces';
import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import DomainResource from '../resources/DomainResource';

class ConfigManager {
  public get = async (): Promise<DataWrappedResponse<ConfigInterface>> =>
    BackendApiClient.request({
      method: 'GET',
      url: '/store-config',
      params: DomainResource.getFranchiseResolverParams(),
    });
}

export default new ConfigManager();
